
import { defineComponent } from 'vue';
import BackendFilters from '@/components/filters/Backend.vue';
import ChartGrid from '@/views/Courses/ChartGrid.vue';
import CoursesTable from '@/views/Courses/CoursesTable.vue';
import RegionsTable from '@/views/Courses/RegionsTable.vue';

export default defineComponent({
    components: { BackendFilters, ChartGrid, CoursesTable, RegionsTable },
});
